module.exports = __webpack_public_path__ + "static/media/site__2__panel.c49608ab.webp";